// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-j_hl","advertDetailHeaderLocation__value":"c-j_hm"};